// ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ref, onValue, off } from "firebase/database";
import { db } from "../Services/firebase";
import useStore from "../Screen/redux/store/useStore";

// Map module_codes to their corresponding paths
const moduleCodeToPath = {
  dashboard: "/dashboard",
  admins: "/admin",
  role_maping: "/role",
  client: "/client-list",
  admin_recharge: "/admin-recharge",
  recharge_history: "/recharge-history",
  widraw_history: "/withdraw-history",
  announce_result: "/announce-result",
  overall_result: "/overall-result",
  reports: "/report",
  commission_history: "/commission",
  announcements: "/announcement",
  holiday_update: "/holiday-update",
  links: "/add-link",
  lot_price_details: "/lot-price",
  price_details: "/cash-agency",
  app_time_setting: "/app-time",
  help_and_support: "/help-support",
  delete_data: "/delete-data",
  client_activity: "/client-activity",
  blocked_client_list: "/blocked-client",
};

const ProtectedRoute = ({ moduleCode, children }) => {
  const { role, user } = useStore();
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return; // ⛔ wait until user is ready

    const resultRef = ref(db, `/admin/${user.id}/permissions`);

    const handleResult = (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const arrayData = Object.values(data).filter(Boolean);
        setPermissions(arrayData);
      } else {
        setPermissions([]);
      }

      setLoading(false);
    };

    onValue(resultRef, handleResult);

    return () => {
      off(resultRef, "value", handleResult);
    };
  }, [user?.id]);

  // 🔍 Debug logs
  // console.log("moduleCode:", moduleCode);
  // console.log("permissions:", permissions);
  // console.log("loading:", loading);

  // ✅ Super admin
  if (role === true) {
    return children;
  }

  // ⏳ Wait until Firebase data loads
  if (loading) {
    return null; // or loader component
  }

  const hasPermission = permissions.some(
    (item) => item?.module_code === moduleCode,
  );

  if (!hasPermission) {
    // User doesn't have permission for this route
    // Find the first allowed module_code and redirect there
    if (permissions.length > 0) {
      const firstAllowedModule = permissions[0]?.module_code;
      const redirectPath = moduleCodeToPath[firstAllowedModule];

      if (redirectPath) {
        console.log("Redirecting to first allowed path:", redirectPath);
        return <Navigate to={redirectPath} replace />;
      }
    }

    // If no permissions or no valid path found, redirect to login
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
